import type { ReactNode } from "react";

interface OptionTileProps {
  selected: boolean;
  onToggle: () => void;
  title: ReactNode;
  detail?: ReactNode;
  marker?: ReactNode;
  disabled?: boolean;
}

/** A tappable checkbox-style row (checklists, services, payment methods). */
export function OptionTile({
  selected,
  onToggle,
  title,
  detail,
  marker,
  disabled,
}: OptionTileProps) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={selected}
      disabled={disabled}
      onClick={onToggle}
      className={`flex w-full items-start gap-3 rounded-[var(--radius-control)] border-[1.5px] p-3.5 text-left transition-colors disabled:opacity-50 ${
        selected
          ? "border-accent bg-accent-tint"
          : "border-border bg-surface hover:border-border-strong"
      }`}
    >
      <span
        aria-hidden="true"
        className={`inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-[13px] font-bold ${
          selected ? "bg-accent text-on-accent" : "bg-surface-high text-text-muted"
        }`}
      >
        {selected ? "✓" : marker}
      </span>
      <span>
        <span className="block text-[14.5px] font-semibold text-text">{title}</span>
        {detail ? <span className="block text-[13px] text-text-muted">{detail}</span> : null}
      </span>
    </button>
  );
}
